import { render } from "./LaporanView.vue?vue&type=template&id=3b16b4ee"
import script from "./LaporanView.vue?vue&type=script&lang=js"
export * from "./LaporanView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__